import { Accordion } from 'react-bootstrap'
import { AccordionItemContainer } from './style'

function AccordionItem({
  onClick = () => {},
  className = '',
  eventKey = '',
  selectedToggle,
  setSelectedToggle,
  renderToggle = () => {},
  renderWhenExpanded = () => {},
}) {
  return (
    <AccordionItemContainer className={className}>
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header
          variant="link"
          as={'div'}
          className="custom-accordion-toggler"
          eventKey={eventKey}
          onClick={() => {
            if (selectedToggle !== eventKey) {
              setSelectedToggle(eventKey)
            } else {
              setSelectedToggle('')
            }
            onClick()
          }}
        >
          {renderToggle()}
        </Accordion.Header>
        <Accordion.Body className={selectedToggle[`${eventKey}`]}>
          {renderWhenExpanded()}
        </Accordion.Body>
      </Accordion.Item>
    </AccordionItemContainer>
  )
}

export default AccordionItem
